// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"371":"2ca8cfda","453":"5a3fd20e"}[chunkId] + ".chunk.js";
};